@if (data$ | async; as data) {
  <custom-cx-navigation-ui
    [node]="node$ | async"
    [ngClass]="data.styleClass ?? ''"
    [wrapAfter]="+(data.wrapAfter ?? '')"
    [resetMenuOnClose]="data.resetMenuOnClose"
    [navAriaLabel]="'navigation.categoryNavLabel' | cxTranslate"
  ></custom-cx-navigation-ui>
}
